export default "/icon_search.a5b0b64a-b14555.png";